export default __webpack_public_path__ + "db89b26d3569b3acb012d2b4f185a196.png";